/* ZAIRA FASHION — bulletproof cart remove, global on every page.
   This theme has a broken/duplicated cart-drawer-items custom element
   registration (standard-actions-override.js and cart-drawer.js both try
   to define it — whichever loses throws). Rather than depend on that
   fragile machinery at all, this intercepts every remove-button click in
   the CAPTURE phase (before Dawn's own listener runs), stops it there,
   and does a direct, minimal /cart/change.js call of our own. Works
   identically in the drawer and on the standalone /cart page. */
(function () {
  function currencyPrefix() {
    var sample = document.querySelector('.totals__total-value, .price');
    if (sample) {
      var m = sample.textContent.match(/^[^\d]+/);
      if (m && m[0].trim()) return m[0].trim() + ' ';
    }
    return 'Rs.';
  }

  function money(cents) {
    var value = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return currencyPrefix() + value;
  }

  function handleRemove(root) {
    var idx = root.dataset.index;
    if (!idx) return;
    root.style.opacity = '.35';
    root.style.pointerEvents = 'none';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(idx, 10), quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.item_count === 0) {
          window.location.reload();
          return;
        }
        var row = document.getElementById('CartDrawer-Item-' + idx) || document.getElementById('CartItem-' + idx);
        if (row) row.remove();

        document.querySelectorAll('.totals__total-value').forEach(function (el) {
          el.textContent = money(cart.total_price);
        });
        document.querySelectorAll('[id^="cart-icon-bubble"] .cart-count-bubble span[aria-hidden], .cart-count-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('cart-remove-button');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handleRemove(trigger);
  }, true);
})();
